var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"graph",staticClass:"div",style:(_vm.cssVars)},[_c('span',{ref:"span",staticClass:"span"},[_vm._v(_vm._s(_vm.valor)+"%")]),_c('canvas',{ref:"canvas",staticClass:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }